import { useEffect, useState } from "react";

const MOBILE_QUERY = "(max-width: 900px)";

const readMobile = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(MOBILE_QUERY).matches;

// Mobile layout (cards and folded filters) at 900 px or less.
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(readMobile);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
    const media = window.matchMedia(MOBILE_QUERY);
    const handleChange = (event) => setIsMobile(event.matches);
    setIsMobile(media.matches);

    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", handleChange);
      return () => media.removeEventListener("change", handleChange);
    }

    media.addListener?.(handleChange);
    return () => media.removeListener?.(handleChange);
  }, []);

  return isMobile;
}
